import type { PropsWithChildren, ReactNode } from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import Close from '@engineering/icons/close';
import type { OverlaySize, OverlayTitlePosition } from './types';
import {
  Backdrop,
  Wrapper,
  Content,
  TitleWrapper,
  Title,
  ScrollableContent,
  StyledIconButton,
  Footer,
} from './Overlay.styles';

type Props = PropsWithChildren<{
  title?: ReactNode;
  titlePosition?: OverlayTitlePosition;
  open: boolean;
  width?: OverlaySize;
  onClose: () => void;
  footerContent?: ReactNode;
  fullViewport?: boolean;
}>;

const Overlay = ({
  title,
  titlePosition = 'auto',
  footerContent,
  children,
  open,
  width = 'normal',
  onClose,
  fullViewport,
}: Props) => (
  <Dialog onClose={onClose} open={open}>
    <Backdrop />
    <Wrapper $width={width}>
      <DialogPanel>
        <Content $fullViewport={fullViewport}>
          <TitleWrapper $hasTitle={!!title}>
            {title && (
              <DialogTitle as="div">
                <Title $titlePosition={titlePosition}>{title}</Title>
              </DialogTitle>
            )}
            <StyledIconButton
              icon={Close}
              title="close" // @TODO: Add translation
              onClick={onClose}
            />
          </TitleWrapper>
          <ScrollableContent $fullViewport={fullViewport}>
            {children}
          </ScrollableContent>
          {footerContent && (
            <Footer $fullViewport={fullViewport}>{footerContent}</Footer>
          )}
        </Content>
      </DialogPanel>
    </Wrapper>
  </Dialog>
);

export { Overlay };
